export default __webpack_public_path__ + "static/media/rico-nasty.ca9f1eb0.png";